import { TApplicationState } from "../rootReducer";

export const getFileUrls = (state:TApplicationState) =>{
    return state.usersAnketa.documents ?? {};
}